"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
const Button_1 = require("../Button");
const Flex_1 = require("../Flex");
const Modal_1 = require("../Modal");
const ModalBody_1 = require("../ModalBody");
const ModalHeader_1 = require("../ModalHeader");
function Alert(_a) {
    var { children, title = 'Alert' } = _a, props = __rest(_a, ["children", "title"]);
    const cancelButtonRef = react_1.useRef(null);
    return (jsx_runtime_1.jsxs(Modal_1.Modal, Object.assign({ leastDestructiveRef: cancelButtonRef }, props, { children: [jsx_runtime_1.jsx(ModalHeader_1.ModalHeader, { children: title }, void 0),
            jsx_runtime_1.jsxs(ModalBody_1.ModalBody, { children: [jsx_runtime_1.jsx(Box_1.Box, { children: children }, void 0),
                    jsx_runtime_1.jsx(Flex_1.Flex, { children: jsx_runtime_1.jsx(Button_1.Button, Object.assign({ ref: cancelButtonRef, onClick: props.onDismiss, ml: "auto", variant: "secondary" }, { children: "Cancel" }), void 0) }, void 0)] }, void 0)] }), void 0));
}
exports.Alert = Alert;
//# sourceMappingURL=index.js.map